import { useMutation, useQuery } from "@tanstack/react-query";
import valueReferencesService from "src/queries/services/valueReferences";
import { FETCH_QUERY_KEYS } from "../consts";

export const useFetchValueReferenceDefaults = ({ enabled = true } = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.VALUE_REFERENCE_DEFAULTS],
  queryFn: ({ signal }) => valueReferencesService.fetchValueReferenceDefaults({ signal }),
  enabled
});

export const useFetchValueReferenceOverrides = (assistantId, { enabled = true } = {}) => useQuery({
  queryKey: [FETCH_QUERY_KEYS.VALUE_REFERENCE_OVERRIDES, assistantId],
  queryFn: () => valueReferencesService.fetchValueReferenceOverrides(assistantId),
  enabled: !!assistantId && enabled
});

export const useCreateValueReferenceOverride = (options = {}) => useMutation({
  mutationFn: (data) => valueReferencesService.createValueReferenceOverride(data),
  ...options
});

export const useUpdateValueReferenceOverride = (options = {}) => useMutation({
  mutationFn: (data) => valueReferencesService.updateValueReferenceOverride(data),
  ...options
});

export const useDeleteValueReferenceOverride = (options = {}) => useMutation({
  mutationFn: (data) => valueReferencesService.deleteValueReferenceOverride(data),
  ...options
});
